import {
  FETCH_FOLDERS_SUCCESS,
  ADD_FOLDER_SUCCESS,
  EDIT_FOLDER_SUCCESS,
  FETCH_FOLDER_SUCCESS,
  PERMANENTLY_DELETE_SUCCESS,
  MOVE_TO_TRASH_SUCCESS,
  RESTORED_FROM_TRASH_SUCCESS,
  MOVE_FOLDER_SUCCESS,
  FETCH_ACTIVITY_LOGS_SUCCESS,
} from "~/store/action_types";

const folders = (state = {}, action) => {
  switch (action.type) {
    case FETCH_ACTIVITY_LOGS_SUCCESS:
    case ADD_FOLDER_SUCCESS:
    case FETCH_FOLDER_SUCCESS:
    case FETCH_FOLDERS_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { folders = {} } = entities;
      return { ...state, ...folders };
    }
    case EDIT_FOLDER_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { single: id } = result;
      return {
        ...state,
        [id]: entities.folders[id],
      };
    }
    case MOVE_FOLDER_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { folders = {} } = entities;
      const { single: id } = result;
      if (id > 0) {
        return {
          ...state,
          [id]: folders[id],
        };
      }
      return state;
    }
    case RESTORED_FROM_TRASH_SUCCESS:
    case MOVE_TO_TRASH_SUCCESS: {
      const { response = {}, objectType } = action;
      const { entities = {}, result = {} } = response;
      const { folders = {} } = entities;
      const { single: id } = result;
      if (id > 0 && objectType === "Folder") {
        return {
          ...state,
          [id]: folders[id],
        };
      }
      return state;
    }
    case PERMANENTLY_DELETE_SUCCESS: {
      const { id = 0, objectType } = action;

      if (id > 0 && objectType === "Folder") {
        const { [id]: value, ...nextState } = state;
        return nextState;
      }

      return state;
    }
    default:
      return state;
  }
};

export default folders;
